import { render, staticRenderFns } from "./compliance-archives.vue?vue&type=template&id=2dc46210&scoped=true&"
import script from "./compliance-archives.vue?vue&type=script&lang=js&"
export * from "./compliance-archives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc46210",
  null
  
)

export default component.exports